<div class="modal-header border-0 p-2 p-md-3">
    <h5 class="fw-bold mb-0 text-dark">Select Date Range</h5>
    <button type="button" class="btn-close ms-0" aria-label="Close" (click)="cancel()"></button>
</div>

<div class="modal-body px-2 px-md-3">
    <div class="datepicker-container d-flex justify-content-center w-100 border border-light-subtle rounded-3 bg-white p-3 shadow-none">
        <ngb-datepicker #datepicker (dateSelect)="onDateSelection($event)" [markDisabled]="disableFuture"
            [displayMonths]="displayMonths" [dayTemplate]="modalDay" [outsideDays]="'hidden'" navigation="select" 
            [startDate]="getCalendarStartDate()" class="border-0 shadow-none">
        </ngb-datepicker>

        <ng-template #modalDay let-date let-focused="focused">
            <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
                [class.range-start]="isFrom(date)" [class.range-end]="isTo(date)"
                [class.faded]="isHovered(date) || isInside(date)" [class.disabled]="disableFuture(date)"
                (mouseenter)="hoveredDate = date" (mouseleave)="hoveredDate = null">
                {{ date.day }}
            </span>
        </ng-template>
    </div>
</div>

<div class="modal-footer border-0 p-md-3 p-2 ">
    <button type="button" class="btn btn-outline-secondary px-4 py-2 small fw-bold shadow-none" (click)="cancel()">Cancel</button>
    <button type="button" class="btn btn-apply px-4 py-2 small fw-bold shadow-none" (click)="apply()" [disabled]="!fromDate || !toDate">Apply Date Range</button>
</div>
